import React, { Component } from "react";

import { IShare } from "@formant/core/model/IShare";

import { appStore } from "../../../stores";
import { Buttons } from "../../common/Buttons";
import { ActionButton } from "../ActionButton";

export interface IActionsProps {
    publish: IShare;
    onRevokePublish: (publish: IShare) => void;
}

export class Actions extends Component<IActionsProps> {
    public render() {
        return (
            <Buttons>
                <ActionButton
                    icon="delete"
                    onClicked={this.onDelete}
                    data-tooltip="Remove publish"
                />
            </Buttons>
        );
    }

    private onDelete = () => {
        const { publish, onRevokePublish } = this.props;
        const message = (
            <p>
                Shared observability links and FEMs associated with this share
                will no longer usable.
            </p>
        );
        appStore.setConfirm({
            title: "Revoke publish",
            message,
            onOk: () => {
                onRevokePublish(publish);
                appStore.setSnackbar("Publish revoked");
            },
        });
    };
}
